export default __webpack_public_path__ + "static/media/tcd-logo-main.6bcc0f29.svg";